
  import { integrationsService } from '@/services/integrations/integrationsService';
  import prismaticClient from '@/services/integrations/prismaticClient';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { isOnFreePlan } from '@/ui/auth/auth';
  import { computed, defineComponent } from 'vue';
  import { Button } from '@/ui/components/Button';

  interface PauseButtonProps {
    loading: boolean;
    setLoading: (value: boolean) => void;
  }

  export default defineComponent<PauseButtonProps>({
    components: {
      Button,
    },
    props: ['loading', 'setLoading'],
    setup(props) {
      const store = useIntegrationDetailsStore();
      const integration = store.getAndCheckIntegrationActivated();

      const enabled = computed(() => store.isEnabled);

      const enableDisableInstance = () => {
        props.setLoading(true);
        const newStatus = !enabled.value;
        const instanceId = integrationsService.getInstanceId(integration);

        prismaticClient.enableDisableInstance(instanceId, newStatus).then(() => {
          integrationsService.setIntegrationStatus(integration, newStatus);
          props.setLoading(false);
        });
      };

      return {
        isOnFreePlan,
        isEnabled: enabled,
        enableDisableInstance,
      };
    },
  });
